const bg = {
  nav: {
    home: 'Начало',
    artisanBreads: 'Артисан хляб',
    portfolio: 'Портфолио',
    gallery: 'Галерия',
    shop: 'Магазин',
    contact: 'Контакт',
  },
  imageStrip: {
    freshFromOven: 'Масата с хляба',
    breadTable: 'Масата с хляба',
  },
  gallery: {
    all: 'Всички',
    breads: 'Хляб',
    foodDrinks: 'Храни и напитки',
      catering: 'Кетъринг',
      kozunak: 'Козунак',
  },
  menu: {
    bar: 'Бар',
    barSubtitle: 'Коктейли и още',
    catering: 'Снаксове',
    cateringSubtitle: 'Берлин',
    artisanBreads: 'Артисан хляб',
    artisanBreadsSubtitle: 'Домашен занаятчийски хляб и сладкиши',
    hotDrinks: 'Топли напитки',
    hotDrinksSubtitle: 'Кафе фантазии',
    desserts: 'Десерти',
    dessertsSubtitle: 'Торти и сладкиши',
  },
  pages: {
    menu: {
      heroLabel: 'Меню',
      heroTitle: 'Храни и напитки',
      heroText: 'Домашна храна, топли напитки и занаятчийски хляб, приготвени с внимание.',
      heroPassion: 'Истинска страст',
      heroFlavours: 'Естествени вкусове',
      introLabel: 'Grain Bites',
      introTitle: 'Изберете своя фаворит',
      introText: 'Прости съставки, щедри порции и по нещо вкусно за всяко настроение.',
      showcaseTitle: 'Вкусно меню',
      showcaseText: 'Най-добрите предложения от кухнята на Grain Bites',
      menuItem: 'Ястие от менюто',
      barTitle: 'Бар и хапки',
      coffeeTitle: 'Кафе',
      teaTitle: 'Чай',
      dessertsTitle: 'Десерти',
      viewAll: 'Виж всички',
      openMenu: 'Отвори',
      openDetails: 'Отвори детайли за',
      close: 'Затвори детайлите',
      ingredientsLabel: 'Съставки',
      descriptions: {
        bar: 'Внимателно приготвени напитки и малки хапки за спокоен момент.',
        coffee: 'Любими топли кафета, приготвени с внимание за всеки ден.',
        tea: 'Подбрани ароматни чайове, сервирани топли и готови за наслада.',
        desserts: 'Прясно приготвени сладки изкушения за фин завършек.',
      },
      featured: {
        breakfastTitle: 'Меню за закуска',
        breakfastText: 'Свежо начало от 8:00 до 12:00 ч.',
        lunchTitle: 'Обедно меню',
        lunchText: 'Вкусна храна за приятна обедна почивка',
      },
      columns: {
        breakfast: 'Закуска',
        lunch: 'Обяд',
      },
      items: {
        morningEggToast: 'Сутрешен тост с яйце',
        breakfastPlate: 'Закуска в чиния',
        sweetKozunak: 'Сладък козунак',
        seasonalPlate: 'Сезонна чиния',
        grainBowl: 'Купа със зърнени храни',
        sharedTable: 'Споделена трапеза',
        warmLunchPlate: 'Топла обедна чиния',
        sweetFinish: 'Сладък завършек',
      },
      ingredients: {
        morningEggToast: 'Квасен хляб / яйце / масло / сезонни зелени подправки',
        breakfastPlate: 'Яйца / квасен хляб / зелени салати / билки',
        sweetKozunak: 'Яйце / масло / цитруси / пшенично брашно',
        seasonalPlate: 'Свежи зеленчуци / билки / домашен дресинг',
        grainBowl: 'Зърнени храни / зелени салати / печени зеленчуци',
        sharedTable: 'Хляб / разядки / зеленчуци / билки',
        warmLunchPlate: 'Зърнени храни / печени зеленчуци / билки',
        sweetFinish: 'Свежи плодове / сладкиш / домашен крем',
      },
    },
    contact: {
      eyebrow: 'Grain Bites',
      title: 'Контакт',
      intro: 'Нека поговорим за вашето следващо събитие, меню или кетъринг идея.',
      sectionLabel: 'Къде сме',
      heading: 'Елате да се запознаем',
      description: 'Ще се радваме да се свържете с нас и заедно да създадем нещо вкусно.',
      sendLabel: 'Изпратете съобщение',
      formTitle: 'Кажете от какво имате нужда',
      name: 'Име',
      email: 'Имейл',
      message: 'Съобщение',
      send: 'Изпрати съобщение',
      sending: 'Изпращане...',
      success: 'Благодарим — съобщението ви беше изпратено.',
      error: 'Съобщението не беше изпратено. Моля, опитайте отново.',
    },
    blogPost: {
      label: 'Журнал на Grain Bites',
      title: 'Защо квасът има нужда от време',
      intro: 'Поглед към ферментацията, вкуса и умението зад всеки хляб.',
      overviewTitle: 'Защо квасът има нужда от време',
      overviewIntro: 'Поглед към ферментацията, вкуса и умението зад всеки хляб.',
      basicsTitle: 'Какво е квас?',
      basicsIntro: 'Как брашното, водата, дивите дрожди и времето създават хляб с характер.',
      benefitsTitle: 'Предимствата на хляба с квас',
      benefitsIntro: 'Защо естествено ферментиралият хляб е богат на вкус и лесен за храносмилане.',
      processTitle: 'От кваса до коричката',
      processIntro: 'Търпеливите стъпки, които превръщат активния квас в хляб със златиста коричка.',
      back: 'Обратно към журнала',
      notFound: 'Тази история не е намерена.',
      published: 'Публикувано',
      contentsFermentation: 'Ферментацията създава характер',
      contentsCrust: 'От кваса до коричката',
      categoryBread: 'Артисан хляб',
      categorySourdough: 'Квас',
      categoryTea: 'Чай и моменти',
      categoryMenu: 'Храна и напитки',
      fermentationTitle: 'Ферментацията създава характер',
      fermentationIntro: 'Как бавната ферментация развива аромата, структурата и вкуса на хляба с квас.',
      crustTitle: 'От кваса до коричката',
      crustIntro: 'Търпеливите стъпки, които превръщат активния квас в хляб със златиста коричка.',
      contentsFermentationHow: 'Как работи ферментацията',
      contentsFermentationTime: 'Време и температура',
      contentsCrustStarter: 'Освежаване на кваса',
      contentsCrustBake: 'Изпичане на хляба',
      overviewContentsTrend: 'Повече от тенденция',
      overviewContentsWhat: 'Какво е квас?',
      overviewContentsBenefits: 'Предимства на кваса',
      overviewContentsCrust: 'От кваса до коричката',
      contentsBasicsWhat: 'Какво е квас?',
      contentsBasicsTrend: 'Защо квасът е важен',
      contentsBenefitsCharacter: 'Вкус и характер',
      contentsProcessPatience: 'Търпение в процеса',
      contentsProcessBake: 'От тестото до коричката',
    },
    artisanBreads: {
      eyebrow: 'Grain Bites',
      title: 'Артисан хляб',
      intro: 'Домашен занаятчийски хляб и сладкиши',
      tagline: 'От жив квас до златиста кора',
      sectionLabel: 'Прясно изпечено',
      heading: 'Хубавият хляб изисква време',
      description: 'Нашият занаятчийски хляб е създаден за големи трапези, спокойни сутрини и незабравими събирания. Всеки хляб е приготвен с внимание и се сервира пресен.',
      sourdoughTitle: 'Печенето с квас е повече от тенденция',
      sourdoughIntro: 'То е завръщане към вековно занаятчийство. Когато сами печете хляб с квас, усещате не само неповторимия аромат на прясно изпечен хляб, но се възползвате и от множество здравословни ползи и уникален вкус.',
      sourdoughLabel: 'Квас',
      sourdoughWhatTitle: 'Какво е квас?',
      sourdoughWhatText: 'Квасът е естествена смес от брашно и вода, която ферментира благодарение на млечнокисели бактерии и диви дрожди. Този процес кара хляба да бухва по естествен начин – без изкуствени набухватели. Дългото втасване развива наситени аромати и особено леко смилаема средина.',
      sourdoughBenefitsTitle: 'Предимства на хляба с квас',
      sourdoughBenefits: [
        'Естествена трайност: Квасът действа като естествен консервант и запазва хляба свеж по-дълго.',
        'По-добра поносимост: Разграждането на фитиновата киселина прави хляба с квас по-лесен за храносмилане и по-богат на хранителни вещества.',
        'Уникален вкус: Съчетанието от меки и леко кисели нотки превръща всеки хляб в ароматно удоволствие.',
        'Здравословни съставки: Без добавки и индустриална мая – само брашно, вода, сол и време.',
      ],
      sourdoughCtaTitle: 'Открийте света на кваса',
      sourdoughCtaText: 'Научете повече за ферментацията, вкуса и занаятчийството зад всеки хляб.',
      sourdoughCtaLink: 'Научете за кваса',
      sourdoughPageTitle: 'Наръчник за кваса',
      sourdoughPageIntro: 'Поглед към ферментацията, вкуса и умението зад всеки хляб.',
      sourdoughBack: 'Обратно към артисан хляба',
      sourdoughTopicsLabel: 'Теми за кваса',
      sourdoughTopics: {
        overview: 'Квас',
        basics: 'Какво е квас?',
        benefits: 'Предимства',
        process: 'От кваса до коричката',
      },
      slowPreparation: 'Бавна подготовка',
      slowPreparationText: 'Време за текстура и вкус.',
      madeForSharing: 'Създаден за споделяне',
      madeForSharingText: 'Перфектен за закуска и кетъринг.',
      planOrder: 'Планирайте поръчка',
      collection: 'Колекцията',
      galleryTitle: 'Изпечено за споделяне',
      viewDetails: 'Виж детайли',
      close: 'Затвори детайлите за продукта',
      ingredients: 'Съставки',
      categories: {
        wholegrain: 'Пълнозърнест',
        white: 'Бял',
        goldenGrain: 'Златно зрънце',
        dinkel: 'Динкел',
        mixes: 'Миксове',
        dinkelRye: 'Динкел-ръж',
        kozunak: 'Козунак',
      },
    },
    portfolio: {
      eyebrow: 'Grain Bites',
      title: 'Портфолио',
      introHeading: 'Подбрани проекти',
      introText: 'Бар, кетъринг трапези, занаятчийски хляб и събития, създадени с внимание в духа на Кройцберг.',
      projects: {
        bar: {
          label: 'Бар и напитки',
          title: 'Коктейлни изживявания',
          text: 'Спокойна бар атмосфера, внимателно подбрани напитки, топло обслужване и място за добри разговори.',
          imageAlt: 'Атмосферата в бара на Grain Bites',
        },
        catering: {
          label: 'Кетъринг',
          title: 'Трапези за споделяне',
          text: 'От бизнес обяди до частни празненства създаваме щедри трапези, които събират хората около прясна храна.',
          imageAlt: 'Кетъринг трапеза на Grain Bites',
        },
        bread: {
          label: 'Артисан хляб',
          title: 'Прясно изпечено',
          text: 'Домашният хляб и сладкишите добавят топъл и запомнящ се акцент към всяко меню и събитие.',
          imageAlt: 'Прясно изпечен занаятчийски хляб',
        },
        events: {
          label: 'Събития',
          title: 'Храна с усещане за място',
          text: 'Създаваме всяко събитие според хората, пространството и малките детайли, които го правят лично.',
          imageAlt: 'Пространство за събитие на Grain Bites',
        },
      },
    },
  },
};

export default bg;
